import { render, staticRenderFns } from "./BaseInlineAlert.vue?vue&type=template&id=bedfc0d0&"
import script from "./BaseInlineAlert.vue?vue&type=script&lang=js&"
export * from "./BaseInlineAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports